import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import config from '../config/index';
import { actions } from '../actions/themeActions';

const NavBar = ({ unit, tenant }) => {
  const dispatch = useDispatch();
  return (
    <div className="navbar-wrapper">
      <div className="nav-wrapper">
      <nav className="flex-nav">
        <div className="logo">
          <a className="page-scroll" href="/">
            <img src={`${config.getBlobUrl(tenant.url)}${unit.shieldUrl}`} alt="Konsultacje społeczne - strona główna" />
            <span>{tenant.name}</span>
          </a>
        </div>
      </nav>
      </div>
      <div className="wcag">
        <div className="controls">
            <div className="wrapper">
                <div className="header header-main">
                  <i className="fab fa-accessible-icon" />
                  <span>Strona <br /> bez barier</span>
                </div>
                <div className="actions">
                  <div className="header">
                    <span>Kontrast</span>
                  </div>
                  <button onClick={() => dispatch(actions.changeTheme())} className="contrast_bw" title="Kontrast standardowy">
                    <span>Kontrast standardowy</span>
                  </button>
                  <button onClick={() => dispatch(actions.changeTheme('style-contrast-yellow-black'))} className="contrast_by" title="Kontrast czarny-żółty">
                    <span>Kontrast czarny-żółty</span>
                  </button>
                </div>
                <div className="link">
                  <a href="/deklaracja-dostepnosci">Deklaracja dostępności</a>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};

NavBar.propTypes = {
  unit: PropTypes.object,
  tenant: PropTypes.object,
};

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/NavBar.js